import { Component, OnInit } from '@angular/core';
import { AppSettings } from '../../PRE-LOAD/app-settings';
import { StringsService } from '../../services/strings/strings.service';
import { CancellationSuccessful } from '../../types/strings.type';
import { UserSelectionsService } from '../../services/user-selections/user-selections.service';
import { Router } from '@angular/router';

@Component({
    selector: 'rttd-booking-cancellation-confirmation',
    templateUrl: './booking-cancellation-confirmation.component.html',
    styleUrls: ['./booking-cancellation-confirmation.component.scss']
})
export class BookingCancellationConfirmationComponent implements OnInit {
    content: CancellationSuccessful;

    constructor(
        private stringsService: StringsService,
        public appSettings: AppSettings,
        private userSelectionService: UserSelectionsService,
        private router: Router
    ) { }

    ngOnInit() {
        // Get route content.
        this.stringsService.get().subscribe((content: CancellationSuccessful) => {
            this.content = content['CancellationSuccessful'];
        });
    }

    /**
     * @description Navigate back to the start of the app and clear all user selection data.
     */
    backToStart() {
        this.userSelectionService.removeAll();
        this.router.navigate(['/'], {
            skipLocationChange: true
        });
    }

}
